import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { DriverMetricAdjustmentUpdateInput } from '../generated/globalTypes';
import { updateDriverMetricAdjustmentMutation, updateDriverMetricAdjustmentMutationVariables } from '../generated/updateDriverMetricAdjustmentMutation';
import { driverMetricAdjustmentFieldsFragment } from '../models/DriverMetricAdjustment';

/**
 * Get a callback to update a DriverMetricAdjustment in the store.
 */
export function useUpdateDriverMetricAdjustmentCallback(): [(id: string, model: DriverMetricAdjustmentUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateDriverMetricAdjustmentMutation, updateDriverMetricAdjustmentMutationVariables>(
        gql`
            mutation updateDriverMetricAdjustmentMutation ($model: DriverMetricAdjustmentUpdateInput!) {
                updateDriverMetricAdjustment(model: $model) {
                    ...driverMetricAdjustmentFields
                }
            }

            ${driverMetricAdjustmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: DriverMetricAdjustmentUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
